import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { BatchProcessModuleType } from 'src/app/enum/batch-processType';
import { DebitOrderNotificationService } from 'src/app/services/debit-order-notification.service';
import Swal from 'sweetalert2';
import { ManageSuspensionPopupComponent } from '../manage-suspension-popup/manage-suspension-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ReportService } from 'src/app/services/report.service';

@Component({
  selector: 'app-product-and-price-change',
  templateUrl: './product-and-price-change.component.html',
  styleUrls: ['./product-and-price-change.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*', display: 'block', padding: '15px' })),
      transition('expanded <=> collapsed', animate('200ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class ProductAndPriceChangeComponent implements OnInit {
  form: FormGroup
  data: any[]
  fileName: string;
  isFileSelected = false
  FileExtention: string;
  file: any;
  batchproductmoduletpe = BatchProcessModuleType
  Exceluploadshow = false
  displayedColumns = [
    "TypeOfProcess",
    "FileName",
    "createdUser",
    "Date",
    "Count",
    "Status",
    "Action"
  ]
  dataSource = new MatTableDataSource()
  show = false
  constructor(
    private formBuilder: FormBuilder,
    private debitordernotificationservice: DebitOrderNotificationService,
    private matdialog: MatDialog,
    private reportService: ReportService
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      AttachmentFileName: [],
      downloadtype: [],
    })
    this.debitordernotificationservice.getProdAndPriceChangeRecords().subscribe((response) => {
      this.data = response
      this.dataSource = new MatTableDataSource(this.data)
    })
    this.show = false

  }

  downloadtemplate() {
    const link = document.createElement('a');
    link.href = 'assets/template/PPCTemplate.xlsx';
    link.download = 'Template.xlsx';
    link.click();
  }

  selectFile() {
    const inputElement = document.createElement('input');
    inputElement.type = 'file';
    inputElement.style.display = 'none';
    document.body.appendChild(inputElement);
    inputElement.click();

    inputElement.addEventListener('change', async (event: any) => {
      const files: FileList = (event.target as HTMLInputElement).files;

      if (!files || files.length === 0) {
        Swal.fire('Warning', 'Please upload a file', 'warning');
        return;
      }
      if (files.length > 1) {
        Swal.fire('Warning', 'Please upload only one file at a time', 'warning');
        return;
      }

      this.file = files[0];
      this.fileName = this.file.name;
      const fileExtension = this.fileName.split('.').pop().toLowerCase();
      const validExtensions = ['csv', 'xlsx', 'xls'];
      const validMimeTypes = ['text/csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'];

      const isValidExtension = validExtensions.includes(fileExtension);
      const isValidMimeType = validMimeTypes.includes(this.file.type);

      if (!isValidExtension || !isValidMimeType) {
        Swal.fire(
          'Warning',
          `Please upload a correct file format (csv, xlsx, xls)`,
          'warning'
        );
        this.fileName = '';
        this.isFileSelected = false;
        document.body.removeChild(inputElement);
        return;
      }
      this.FileExtention = fileExtension;
      this.isFileSelected = true;
      this.form.controls['AttachmentFileName'].setValue(this.fileName);
      console.log(this.file);
      document.body.removeChild(inputElement);
    });
  }

  reset() {
    const txt = 'Are you sure you want to delete?';
    const Yes = 'Yes';
    const No = 'No';
    Swal.fire({
      text: txt,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#7D32DE',
      cancelButtonColor: '#23C00A',
      confirmButtonText: Yes,
      cancelButtonText: No,
    }).then((result) => {
      if (result.value) {
        this.fileName = '';
        this.isFileSelected = false;
        this.form.controls['AttachmentFileName'].setValue(this.fileName);
      }
    });
  }


  download(item) {
    this.reportService.getProductandPriceExcelFile(item.batchProcessorId).subscribe((data) => {
      if (data) {
        const linkSource = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64, ' + data;
        const downloadLink = document.createElement('a');
        const fileName = item.fileName + '.xlsx'
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      }
    })

  }

  downloadExcel() {
    if (this.form.value.downloadtype) {
      debugger
      const link = document.createElement('a');
      link.href = 'assets/template/PriceTemplate.xlsx';
      link.download = 'Price Template.xlsx';

      if (this.form.value.downloadtype == "2") {
        link.href = 'assets/template/ProductTemplate.xlsx';
        link.download = 'Product Template.xlsx';
      }
      else if (this.form.value.downloadtype == "3") {
        link.href = 'assets/template/ProductAndPriceTemplate.xlsx';
        link.download = 'Product And Price Template.xlsx';
      }

      link.click();

    }
  }


  Processtye(e) {
    this.show = false
    setTimeout(() => {
      this.show = true
    }, 200);

  }

  get typeOfFile(): string {
    const downloadType = parseInt(this.form.value.downloadtype);
    return this.gettypeOfFile(downloadType);
  }

  getStatusClass(status) {
    switch (status) {
      case 1:
        return 'bg-new';
      case 2:
        return 'bg-inprogress';
      case 3:
        return 'bg-Success';
      case 3:
      case 'Partial Success':
        return 'bg-failed';
      default:
        return '';
    }
  }

  gettypeOfFile(status) {
    switch (status) {
      case 1:
        return 'Price Only';
      case 2:
        return 'Product Only';
      default:
        return 'Price and Product';
    }
  }
  getprocessstatus(status) {
    switch (status) {
      case 1:
        return 'New';
      case 2:
        return 'InProgress';
      case 3:
        return 'Success';
      case 5:
        return 'HCComplete';
      case 6:
        return 'SPComplete';
      default:
        return 'Failed';
    }
  }


  Priceupload(data) {
    let head;
    let title;
    if (data == 1) {
      head = 'Bulk Price Update';
      title = 'price'
    }
    else if (data == 2) {
      head = 'Bulk Product Update';
      title = 'product'
    }
    else {
      head = 'Bulk Price & Product Update ';
      title = 'p&p'
    }

    const dialogref = this.matdialog.open(ManageSuspensionPopupComponent, {
      autoFocus: false,
      disableClose: true,
      panelClass: 'mat-dialog',
      width: "40%",
      data: {
        head: head,
        title: title,
        data: data,
      }
    });
    dialogref.afterClosed().subscribe((result) => {
      // if (result)
      // this.gettabledata();
    })
  }



  upload() {
    if (this.form.valid) {
      let formdata: FormData = new FormData;
      formdata.append('file', this.file)
      formdata.append('BatchProcessModuleType', this.batchproductmoduletpe.ProductAndPriceChange.toString())
      formdata.append('TypeOfFile', this.form.value.downloadtype)
      this.debitordernotificationservice.getProductAndPriceExcelFileUploaderInstance(formdata).subscribe((response) => {
        if (response.status == "Mismatch_Header") {
          Swal.fire('Error!', 'Confirm the accuracy of the headers in Excel .', 'error')

        }

        else if (response.status == "Mismatch_Column_Count") {
          Swal.fire('Error!', 'Confirm the accuracy of the columns in Excel..', 'error')
        }

        else if (response.status == "success") {
          Swal.fire('Success!!!', 'The upload of the Excel file was successful, and the processing will commence shortly', 'success')
        }
        this.isFileSelected = false;
        this.form.reset()

      })
    }


  }
  clearFilter() {
    this.ngOnInit()
  }
}
